<template>
  <v-container fluid class="pa-0">
    <v-card outlined class="rounded-lg pa-4">
      <div class="d-flex align-center mb-4">
        <v-avatar size="48" class="section-icon mr-3" rounded>
          <v-icon color="white">mdi-web-outline</v-icon>
        </v-avatar>
        <div>
          <div class="text-subtitle-1 font-weight-bold primary--text">{{ isEdit ? 'Edit School Website' : 'Create School Website' }}</div>
          <div class="text-caption grey--text">Set your website title and subdomain to get started</div>
        </div>
      </div>

      <v-form ref="form" v-model="formValid" lazy-validation>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.title"
              :rules="[v => !!v || 'Title is required']"
              label="Website Title"
              outlined
              prepend-inner-icon="mdi-format-title"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.subdomain"
              :rules="[
                v => !!v || 'Username is required',
                v => /^[a-z0-9-]+$/.test(v) || 'Only lowercase letters, numbers, and dashes allowed'
              ]"
              label="School Website Username (for subdomain)"
              hint="Only lowercase letters, numbers, and dashes. Used as subdomain."
              outlined
              prepend-inner-icon="mdi-at"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              :value="subDUrl"
              label="Subdomain URL"
              hint="e.g. https://yourname.mysch.ng"
              outlined
              prepend-inner-icon="mdi-link-variant"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>

      <v-btn color="primary" rounded elevation="2" class="font-weight-bold text-none" :loading="loading" @click="submit">
        <v-icon left>{{ isEdit ? 'mdi-content-save-outline' : 'mdi-plus' }}</v-icon>
        {{ isEdit ? 'Update' : 'Create' }}
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  props: ['school', 'authToken', 'website'],

  data() {
    return {
        formValid: false,
        loading: false,
        form: {
            id: '',
            title: '',
            subdomain: '',
            custom_domain: '',
            status: 'pending'
        }
    };
  },
    watch: {
        website: {
            handler(newWebsite) {
            if (newWebsite) {
                this.form = {
                    id: newWebsite.title || '',
                    title: newWebsite.title || '',
                    subdomain: newWebsite.subdomain || '',
                    custom_domain: newWebsite.custom_domain || '',
                    status: newWebsite.status || 'pending'
                };
            }
            },
            immediate: true, // triggers on component mount as well
            deep: true
        }
    },


  computed: {
    isEdit() {
      return !!this.website?.created_at;
    },
    subDUrl() {
      return this.form.subdomain ? `https://${this.form.subdomain}.mysch.ng` : '';
    }
  },

  methods: {
    async submit() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) return;

      if (!this.school?.school_id) {
        this.$toast.error('Missing school ID.');
        return;
      }

      this.loading = true;

      try {
        const url = `${process.env.VUE_APP_BASEURL}/websites?school_id=${this.school.school_id}`;

        if (this.isEdit) {
          await axios.post(url, this.form, {
            headers: { Authorization: 'Bearer ' + this.authToken }
          });
          this.$toast.success('School Website updated');
        } else {
          await axios.post(url, this.form, {
            headers: { Authorization: 'Bearer ' + this.authToken }
          });
          this.$toast.success('School Website created');
        }

        this.$router.push({ name: 'SchoolWebsiteDashboard' });
      } catch (error) {
        console.error(error);
        this.$toast.error('Failed to save website. Check your input or try again.');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.section-icon {
    background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
}
</style>
